import { create } from 'zustand';

import { lmmDefectenStateCreator } from './lmmDefectenStateCreator';
import lmmSidepanelStateCreator from './lmmSidepanelStateCreator';
import lmmVoorraadStateCreator from './lmmVoorraadStateCreator';
import { LmmStore } from './types';

const useLmmStore = create<LmmStore>()((set, get, _store) => ({
  ...lmmVoorraadStateCreator(set, get, _store),
  ...lmmSidepanelStateCreator(set, get, _store),
  ...lmmDefectenStateCreator(set, get, _store),
  reset: () => {
    get().resetLmmVoorraad();
    get().resetLmmSidepanel();
  },
}));

export default useLmmStore;
